<template>
  <a :href="linkout ? url : homeUrl + url" target="_blank" rel="noopener noreferrer" :data-gtm-category="`p-${gtm.category}`" :data-gtm-label="gtm.label"
     :data-gtm-action="gtm.action">{{name}}
    <div v-if="description" class='nav_sub_description'>{{description}}</div>
  </a>
</template>

<script>
  export default {
    name: 'AppLink',
    props: ['link', 'homeUrl', 'description'],
    data () {
      return {
        name: this.link.name,
        url: this.link.url,
        gtm: this.link.gtm,
        linkout: this.link.linkout
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppLink.vue?39d9f22c